var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    {
      attrs: {
        align: "stretch"
      }
    },
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12",
            md: "6"
          }
        },
        [_c("profile-card")],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12",
            md: "6"
          }
        },
        [_c("payment-card")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }